export * from './provisionalDetail';
